import React from 'react';
import PropTypes from 'prop-types';
import MarkushValue from '@Components/Results/substances/tables/markush/markush-value.component.jsx';
import StructurePreviewComponent from '@Components/Results/structure/structure-preview.component.jsx';

export default class MarkushGroup extends React.PureComponent {

  render() {
    const { uid, group } = this.props;

    return (
      <tbody id={`${uid}-${group.label}`}>
        {group.members &&
          group.members.map((member, index) => (
            <tr>
              <td>{index === 0 ? group.label : ''}</td>
              {!member.path && (
                <td>
                  <MarkushValue value={member.data.value} uid={uid} />
                </td>
              )}
              {member.path && (
                <td className='markush-picture'>
                  <StructurePreviewComponent markushPreview={member.path} />
                </td>
              )}
              <td>{member.data && member.data.size}</td>
              <td>{member.data && member.data.attributes}</td>
              <td>{member.data && <MarkushValue value={member.data.substitutedBy} uid={uid} />}</td>
              <td>{member.data && member.data.frequency}</td>
            </tr>
          ))}
      </tbody>
    );
  }
}

MarkushGroup.propTypes = {
  uid: PropTypes.string.isRequired,
  group: PropTypes.object.isRequired,
};
